import React from 'react';
import styled from 'styled-components';
import MotifButton from './MotifButton';
import MotifContentSwitcher from '@ey/motif-react-wrapper/ContentSwitcher';

export default function ContentSwitcher({data, disabled, onClick, variant, noOfLines, activeIndex, children}) {
	return (
		<StyledMotifContentSwitcher className="StyledMotifContentSwitcher">
			{children ? (
				children
			) : (
				<>
					{data.map((data, index) => {
						return (
							<MotifButton
								id={data.id}
								name={data.Name}
								onClick={onClick}
								variant={variant}
								className={`${activeIndex === index + 1 ? 'motif-active' : ''}`}
								disabled={disabled}
								showLabel
								isEllipsed
								buttonLabel={data.Name}
								noOfLines={noOfLines}
							/>
						);
					})}
				</>
			)}
		</StyledMotifContentSwitcher>
	);
}

const StyledMotifContentSwitcher = styled(MotifContentSwitcher)``;
